module.exports = __webpack_public_path__ + "static/img/FK.54c692dd.svg";